import { matchPath } from "react-router-dom";

type ModuleNames = string;

export function linkToCreationHome() {
  return "/creation";
}

export function isInCourseCreation(pathname: string) {
  return matchPath(pathname, {
    path: linkToCreationHome(),
    exact: false
  });
}

export function linkToTags() {
  return `${linkToCreationHome()}/tags`;
}

export function linkToExamQuestions() {
  return `${linkToCreationHome()}/exam-questions`;
}

export function linkToCreateExamQuestion() {
  return `${linkToExamQuestions()}/create`;
}

export function linkToEditExamQuestion(questionId: string = ":questionId") {
  return `${linkToExamQuestions()}/edit/${questionId}`;
}

export function linkToExamQuestionAnswers(questionId: string = ":questionId") {
  return `${linkToExamQuestions()}/answers/${questionId}`;
}

export function linkToCourse(courseId: string = ":courseId") {
  return `${linkToCreationHome()}/course/${courseId}`;
}

export function linkToNewCourse() {
  return `${linkToCreationHome()}/new-course`;
}

export function linkToSection(
  courseId: string = ":courseId",
  sectionId: string = ":sectionId"
) {
  return `${linkToCourse(courseId)}/section/${sectionId}`;
}

export function linkToNewModuleType(
  courseId: string = ":courseId",
  sectionId: string = ":sectionId",
  contentId: string = ":contentId"
) {
  return `${linkToSection(
    courseId,
    sectionId
  )}/content/${contentId}/new-module-type`;
}

export function linkToNewModuleForm(
  courseId: string = ":courseId",
  sectionId: string = ":sectionId",
  contentId: string = ":contentId",
  moduleType: ModuleNames | ":moduleType" = ":moduleType"
) {
  return `${linkToSection(
    courseId,
    sectionId
  )}/content/${contentId}/new-module/${moduleType}`;
}

export function linkToEditModuleForm(
  courseId: string = ":courseId",
  sectionId: string = ":sectionId",
  contentId: string = ":contentId",
  contentModuleId: string = ":contentModuleId"
) {
  return `${linkToSection(
    courseId,
    sectionId
  )}/content/${contentId}/module/${contentModuleId}`;
}

export function linkToImportEntity(
  courseId: string = ":courseId",
  sectionId: string = ":sectionId"
) {
  return `${linkToSection(courseId, sectionId)}/import-content`;
}

export function linkToTranslateContent(
  courseId: string = ":courseId",
  sectionId: string = ":sectionId",
  contentId: string = ":contentId"
) {
  return `${linkToContentView(courseId, sectionId, contentId)}/translate`;
}

export function linkToTranslateContentModule(
  courseId: string = ":courseId",
  sectionId: string = ":sectionId",
  contentId: string = ":contentId",
  moduleId: string = ":moduleId"
) {
  return `${linkToEditModuleForm(
    courseId,
    sectionId,
    contentId,
    moduleId
  )}/translate`;
}

export function linkToContentView(
  courseId: string = ":courseId",
  sectionId: string = ":sectionId",
  contentId: string = ":contentId"
) {
  return `${linkToSection(courseId, sectionId)}/content/${contentId}`;
}

export const idOfModuleEditPage = (
  pathname: string
): string | null | undefined => {
  const match: any = matchPath(pathname, {
    path: linkToEditModuleForm(),
    exact: true
  });
  return match && match.params.contentModuleId;
};

const newModulePaths = [linkToNewModuleForm(), linkToNewModuleType()];

export const atNewModulePath = (pathname: string): boolean =>
  newModulePaths.some(path =>
    matchPath(pathname, {
      path,
      exact: true
    })
  );
